module.exports = __webpack_public_path__ + "img/icon_home2.4c3dd309.png";